<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="submit"
  >
    <h1>Registrierung</h1>

    <el-card v-if="errors.length">
      <el-alert
        v-for="(error, index) in errors"
        :key="index"
        :closable="false"
        show-icon
        :title="error"
        type="error"
      />
    </el-card>

    <el-card v-if="errors.email && errors.email.length">
      <el-alert
        v-for="error in errors.email"
        :key="error"
        :closable="false"
        show-icon
        :title="error"
        type="error"
      />
    </el-card>

    <el-form-item
      for="email"
      label="E-Mail-Adresse"
      prop="email"
    >
      <el-input
        id="email"
        v-model="form.email"
        autocomplete="email"
        type="email"
      />
    </el-form-item>

    <el-card v-if="errors.password && errors.password.length">
      <el-alert
        v-for="error in errors.password"
        :key="error"
        :closable="false"
        show-icon
        :title="error"
        type="error"
      />
    </el-card>

    <el-row :gutter="32">
      <el-col :md="12">
        <el-form-item
          for="password"
          label="Passwort"
          prop="password"
        >
          <el-input
            id="password"
            v-model="form.password"
            autocomplete="new-password"
            type="password"
          />
        </el-form-item>
      </el-col>

      <el-col :md="12">
        <el-form-item
          for="password-repeat"
          label="Passwort wiederholen"
          prop="passwordRepeat"
        >
          <el-input
            id="password-repeat"
            v-model="form.passwordRepeat"
            autocomplete="new-password"
            type="password"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item prop="privacy">
      <el-checkbox
        v-model="form.privacy"
        border
      >
        Ich erkenne die <a
          href="https://www.claussen-simon-stiftung.de/de/stiftung/impressum/"
          rel="noopener"
          target="_blank"
        >
          Datenschutzbestimmungen
        </a> an.
      </el-checkbox>
    </el-form-item>

    <el-form-item>
      <el-button
        :loading="submitStatus === $config.status.LOADING"
        native-type="submit"
        round
        type="primary"
      >
        Registrieren
      </el-button>

      <c-button-link
        round
        :to="{ name: 'login' }"
      >
        Zum Login
      </c-button-link>
    </el-form-item>
  </el-form>
</template>

<script>
import CButtonLink from '@/components/CButtonLink'

import api from '@/api'
import validators from '@/functions/validators'

export default {
  name: 'VSignup',

  metaInfo: {
    title: 'Registrierung'
  },

  components: {
    CButtonLink
  },

  data () {
    return {
      submitStatus: this.$config.status.IDLE,
      form: {
        email: '',
        password: '',
        passwordRepeat: '',
        privacy: false
      },
      errors: {
        email: [],
        password: []
      },
      rules: {
        email: {
          required: true,
          type: 'email',
          message: 'Bitte geben Sie eine E-Mail-Adresse ein.'
        },
        password: [
          {
            required: true,
            message: 'Bitte geben Sie ein Passwort ein.'
          },
          {
            validator: (rule, value, callback) => {
              validators.validateField({
                form: this.$refs.form,
                field: 'passwordRepeat',
                fieldValue: this.form.passwordRepeat,
                callback
              })
            }
          }
        ],
        passwordRepeat: [
          {
            required: true,
            message: 'Bitte wiederholen Sie Ihr Passwort.'
          },
          {
            validator: (rule, value, callback) => {
              validators.compare({
                value,
                comparison: this.form.password,
                message: 'Bitte wiederholen Sie Ihr Passwort.',
                callback
              })
            }
          }
        ],
        privacy: {
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('Bitte stimmen Sie den Bestimmungen zu.'))
              return
            }

            callback()
          }
        }
      }
    }
  },

  methods: {
    resetErrors () {
      this.errors.email = []
      this.errors.password = []
    },
    submit () {
      this.resetErrors()

      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }

        this.submitStatus = this.$config.status.LOADING

        api.signup
          .createAccount(this.form)
          .then(response => {
            this.submitStatus = this.$config.status.success
            this.$router.push({ name: 'signup-created' })
          })
          .catch(error => {
            this.$notify.error({
              title: 'Fehler',
              message: 'Ihr Konto konnte leider nicht angelegt werden.'
            })

            if (error.response && error.response.data) {
              this.errors.email = error.response.data.email
              this.errors.password = error.response.data.password1
            }

            this.submitStatus = this.$config.status.error
          })
      })
    }
  }
}
</script>
